/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OtpRequestDto } from '../../models/otp-request-dto';

export interface ConfirmPhoneNumberStep1$Params {
}

export function confirmPhoneNumberStep1(http: HttpClient, rootUrl: string, params?: ConfirmPhoneNumberStep1$Params, context?: HttpContext): Observable<StrictHttpResponse<OtpRequestDto>> {
  const rb = new RequestBuilder(rootUrl, confirmPhoneNumberStep1.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OtpRequestDto>;
    })
  );
}

confirmPhoneNumberStep1.PATH = '/api/v1/customer/confirm-phone-number/init';
